import React, { useState, useContext, useEffect } from 'react';
import { ManagerAuthContext } from "../context/AuthManager";
import { ToastContainer, toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import moment from "jalali-moment";
import axios from 'axios';
import { FaUserPlus } from 'react-icons/fa'; // استفاده از آیکن
import './card.css';

export const AdminPanel = () => {
  const { currentUserRF } = useContext(ManagerAuthContext);

  const [search, setSearch] = useState('');
  const [searchType, setSearchType] = useState('meli'); // to differentiate between searches
  const [mainList, setMainList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);

  // Functions to get data based on search type
  const getAllProducts = async () => {
    let res;
    if (searchType === 'meli') {
      res = await fetch(`https://clinic.salamatpayanew.ir/Register/sicknesSperiodList/${currentUserRF.nezam}&${search}`);
    } else if (searchType === 'tel') {
      res = await fetch(`https://clinic.salamatpayanew.ir/Register/sicknesSperiodListTEL/${currentUserRF.nezam}&${search.replace("/", "-").replace("/", "-")}`);
    } else if (searchType === 'name') {
      res = await fetch(`https://clinic.salamatpayanew.ir/Register/sicknesSperiodListName/${currentUserRF.nezam}&${search}`);
    }
    setMainList(await res.json());
  };

  const today = moment(new Date(), "YYYY-MM-DD").locale("fa").format("YYYY-MM-DD");

  const insertDoctor = async (nameE, meliE, yearE, insuE) => {
    await axios.post("https://clinic.salamatpayanew.ir/Register/statDoctor", {
      name: nameE,
      meli: meliE,
      year: yearE,
      type: "ارجاع شده",
      stat: "1",
      nezam: currentUserRF.nezam,
      date: moment(new Date(), "YYYY-MM-DD").locale("fa").format("YYYY-MM-DD"),
      insu: insuE
    }).then(() => {
      toast.success("ارجاع با موفقیت انجام شد");
      setMainList([]);
    }).catch((err) => {
      toast.warning("این بیمار به پزشک ارجاع شده است");
    });
  };

  const [showbX, setShowbX] = useState(false);
  const handleClosebX = () => setShowbX(false);
  const handleShowbX = () => setShowbX(true);

  const showPopup = () => {
    handleShowbX(true);
  };

  const [name, setName] = useState('');
  const [meli, setMeli] = useState('');
  const [tel, setTel] = useState('');
  const [insu, setInsu] = useState('');

  const handelInsertUse = async () => {
    await axios.post('https://clinic.salamatpayanew.ir/Register/inserrtCartUser', {
      name: name,
      meli: meli,
      tel: tel,
      insu: insu,
      nezam: currentUserRF.nezam
    }).then(() => {
      toast.success("ثبت با موفقیت انجام شد");
      patwrite();
      handleClosebX(true);
    }).catch((err) => {
      toast.warning("این بیمار در سیستم وجود دارد");
    });
  };

  const patwrite = async () => {
    await axios.post("https://clinic.salamatpayanew.ir/Register/pat_writeTo", {
      nezam: currentUserRF.nezam,
      meli: meli,
      date: insu.replace("/", "-").replace("/", "-"),
    }).then(() => {

    }).catch((err) => {

    });
  };

  // Calculate current page items for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = mainList.slice(indexOfFirstItem, indexOfLastItem);

  // Pagination click handler
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Pagination controls
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(mainList.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  if (currentUserRF.meli === null) {
  } else {
    return (
      <>
        <section className="m-0 content" dir='rtl'>
          <div className="row justify-content-between">
            <div className="col-sm-12 col-md-3">
              <div className="card p-3 mb-3 text-center">
                <i className="fa fa-dollar-sign mb-3"></i>
                <h5>مالی</h5>
                <p>اطلاعات مالی بیمار</p>
              </div>
            </div>
            <div className="col-sm-12 col-md-3">
              <div className="card p-3 mb-3 text-center">
                <i className="fa fa-file-alt mb-3"></i>
                <h5>گزارش</h5>
                <p>گزارش بیماری</p>
              </div>
            </div>
            <div className="col-sm-12 col-md-3">
              <div className="card p-3 mb-3 text-center">
                <i className="fa fa-users mb-3"></i>
                <h5>تعداد بیماران</h5>
                <p>تعداد بیماران ثبت‌شده</p>
              </div>
            </div>
            <div className="col-sm-12 col-md-3">
              <div className="card p-3 mb-3 text-center">
                <i className="fa fa-arrow-right mb-3"></i>
                <h5>ارجاع</h5>
                <p>ارجاع به پزشک</p>
              </div>
            </div>
          </div>
        </section>

        <hr />

        <section className="m-0 content" dir="rtl">
          <div className="row">
            <div className="form-group col-md-3">
              {/* Search Type Selector with Dropdown */}
              <select
                className="form-control custom-dropdown"
                onChange={(e) => setSearchType(e.target.value)}
                value={searchType}
              >
                <option value="meli">کد ملی</option>
                <option value="tel">تاریخ تولد</option>
                <option value="name">نام</option>
              </select>
            </div>

 <div className="form-group col-md-6 d-flex">
  {/* General Search Input */}
  <input
    type="text"
    className="form-control"
    placeholder={`جستجو بر اساس ${searchType === 'meli' ? 'کد ملی' : searchType === 'tel' ? 'تاریخ تولد' : 'نام'}`}
    onChange={(e) => setSearch(e.target.value)}
  />
  {/* Search Button */}
  <button
    className="btn btn-info btn-sm ml-5"
    style={{
      height: '40px',
      padding: '0 10px',
      marginTop:'25px',
      fontSize: '14px',
      marginRight:'15px',
      lineHeight: '1.5', // برای تنظیم محتوای داخل دکمه
    }}
    onClick={getAllProducts}
  >
    جستجو
  </button>
</div>


            {/* دکمه ثبت بیمار جدید */}
            <div className="form-group col-md-12 text-center mb-3">
              <button className="btn btn-success btn-sm btn-icon" onClick={showPopup}>
                <FaUserPlus /> ثبت بیمار جدید
              </button>
            </div>

            {/* جدول */}
            <div className="table-responsive mt-4">
              <table className="table bg-white custom-rounded t-24 table-responsive">
                <thead>
                  <tr className="text-center">
                    <th>ردیف</th>
                    <th>نام بیمار</th>
                    <th>کد ملی</th>
                    <th>شماره تماس</th>
                    <th>تاریخ تولد</th>
                    <th>ارجاع</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((item,index) => {
                    const { id, name, meli, tel, year, insu } = item;
                    return (
                      <tr className="text-center" key={id}>
                        <td>{index+1}</td>
                        <td>{name}</td>
                        <td>{meli}</td>
                        <td>{tel}</td>
                        <td>{insu}</td>
                        <td>
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => insertDoctor(name, meli, year, insu)}
                          >
                            ارجاع به پزشک
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Pagination Controls */}
            <div className="pagination-container">
              <button
                className="btn btn-info btn-sm"
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              >
                قبلی
              </button>
              <span className="page-number">{`صفحه ${currentPage} از ${pageNumbers.length}`}</span>
              <button
                className="btn btn-info btn-sm"
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, pageNumbers.length))}
              >
                بعدی
              </button>
            </div>
          </div>
        </section>

        <Modal show={showbX} onHide={handleClosebX}>
          <Modal.Body>
            <input type="text" className="form-control" placeholder="نام و نام خانوادگی" onChange={(e) => setName(e.target.value)} />
            <input type="text" className="form-control" maxLength={10} placeholder="کد ملی" onChange={(e) => setMeli(e.target.value)} />
            <input type="text" className="form-control" maxLength={11} placeholder="شماره همراه" onChange={(e) => setTel(e.target.value)} />
            <input type="text" className="form-control" maxLength={10} placeholder="تاریخ تولد" onChange={(e) => setInsu(e.target.value)} />
            <div style={{ textAlign: 'center' }}>
              <button className="btn btn-success btn-sm" onClick={handelInsertUse}>ثبت اطلاعات</button>
            </div>
          </Modal.Body>
        </Modal>

        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </>
    );
  }
};
